import { render, staticRenderFns } from "./template-manager-home.vue?vue&type=template&id=be6cf830"
import script from "./template-manager-home.vue?vue&type=script&lang=js"
export * from "./template-manager-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports